import { Link, useLocation } from 'react-router-dom';
import { scrollToSection } from '../../utils/scrollToSection';

// One link that does the right thing:
//   - "/path"  → a real route (react-router Link)
//   - "#id" on the homepage → smooth-scroll to that section
//   - "#id" elsewhere → full navigation to "/#id" (homepage then scrolls)
const SectionLink = ({ href, className, onClick, children, ...props }) => {
  const location = useLocation();
  const isHash = href.startsWith('#');

  if (!isHash) {
    return (
      <Link to={href} className={className} onClick={onClick} {...props}>
        {children}
      </Link>
    );
  }

  const onHome = location.pathname === '/';

  const handleClick = (e) => {
    if (onClick) onClick();
    if (!onHome) return; // let the browser navigate to /#id
    e.preventDefault();
    scrollToSection(href);
    window.history.replaceState(null, '', href);
  };

  return (
    <a href={onHome ? href : `/${href}`} className={className} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default SectionLink;
